import React from "react";
import img from "../../../images/objects.png";
import { motion } from "framer-motion";

const content = [
  {
    title: "Preserving Cultural Identity",
    text: "Every language tells a unique story about its people, traditions, and history. By supporting African languages, we help preserve these cultures and ensure they are passed down to future generations.",
  },
  {
    title: "Promoting Inclusivity",
    text: "Millions of people across Africa speak languages that are underrepresented in global communication tools. Providing technology that supports these languages allows everyone to participate fully in the digital world, no matter their linguistic background.",
  },
  {
    title: "Economic and Educational Growth",
    text: "Access to accurate translations helps businesses, educators, and governments communicate more effectively. This boosts trade, learning, and development opportunities, making it easier for African communities to connect with the global economy.",
  },
  {
    title: "Bridging Communication Gaps",
    text: "Miscommunication due to language barriers can lead to missed opportunities and misunderstandings. By offering reliable translation services, we create pathways for collaboration, knowledge sharing, and mutual understanding.",
  },
];

const MainContentIllustrationSection = () => {
  return (
    <div className="flex flex-col md:flex-row w-full gap-6 md:gap-8 px-4 md:px-8 py-8">
      <div className="flex-1 flex items-center justify-center">
      <motion.img
          src={img}
          alt="Illustration"
          className="max-w-sm w-full md:max-w-md"
          initial={{ x: -100, opacity: 0 }} // Slide-in effect
          animate={{ x: 0, opacity: 1, scale: [1, 1.05, 1] }} // Pulse effect
          whileHover={{ rotate: 5, scale: 1.1 }} // Rotate on hover
          transition={{
            duration: 1.5, // Smooth animation speed
            ease: "easeOut",
            repeat: Infinity,
            repeatType: "reverse",
          }}
        />
      
      </div>

      <div className="flex-1 flex flex-col gap-6">
        {content.map(({ title, text }, index) => (
          <div key={index} className="flex flex-col gap-2 text-left">
            <h2 className="text-xl md:text-2xl font-bold">{title}</h2>
            <p>{text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainContentIllustrationSection;
